
import React, {useEffect} from "react";

// reactstrap components
import {
  Button,
  Card,
  CardHeader,
  CardBody,
  CardTitle,
  Row,
  Col,
} from "reactstrap";

// core components
import ReactTable from "components/ReactTable/ReactTable.js";
import { useSelector } from 'react-redux'

function CityAreaList(props) {

  useEffect(() => {
    setDn([])
  }, [props.city, props.area])

  const [dn , setDn] = React.useState([]) 
   let data =  useSelector(state => state.areaStore.areaData).filter(m => m.cityCode === props.city.cityCode).map((prop, key) => {
     prop.area.map((aa,k) =>{
              dn.push({
                id: k,
                cityNameen: prop.cityName.en ,
                cityNamear: prop.cityName.ar ,
                cityCode : prop.cityCode,
                areaen : aa.en,
                areaar : aa.ar,
                areaCode : aa.areaCode,
                actions: (
                    // we've added some custom button actions
                    <div className="actions-right">
                   
                     
                      <Button
                        onClick={() => {
                       //     let obj = dn.find((o) => o.id === k);
                         //   console.log(obj)
                           props.delareacity(prop.cityCode, aa.areaCode)
                        }}
                        color="danger"
                        size="sm"
                        className="btn-icon btn-link remove"
                      >
                        <i className="fa fa-times" />
                      </Button>{" "}
                    </div>
                  ),
            })
        }
    )
   })

 

  return (
    <>
   
      <div className="content">
        <Row>
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">City-Area</CardTitle>
              </CardHeader>
              <CardBody>
                <ReactTable
                  data= {dn}
                  columns={[
                    {
                        Header: "Area Code",
                        accessor: d =>  d.areaCode ,
                      },
                    {
                      Header: "Area",
                      accessor: d =>  d.areaen  + " - " + d.areaar,
                    },
                   
                    {
                      Header: "City",
                      accessor: d => d.cityNameen +" - " + d.cityNamear,
                    },
                   
                    {
                      Header: "Actions",
                      accessor: "actions",
                      sortable: false,
                      filterable: false,
                    },
                  ]}
                  /*
                      You can choose between primary-pagination, info-pagination, success-pagination, warning-pagination, danger-pagination or none - which will make the pagination buttons gray
                    */
                  className="-striped -highlight primary-pagination"
                />
              </CardBody>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  );
}

export default CityAreaList;